export const FOOTER_TRANSLATION_SCOPE = 'footer';
